import React from "react"
import loud from "../images/loud.png"
import loudBlack from "../images/loud-black.png"
import mute from "../images/mute.png"
import muteBlack from "../images/mute-black.png"
import styles from "../App.module.css"

const Mute = props => {
  let soundimg
  if (props.soundmute) {
    if (props.skindark) {
      soundimg = mute
    } else {
      soundimg = muteBlack
    }
  } else {
    if (props.skindark) {
      soundimg = loud
    } else {
      soundimg = loudBlack
    }
  }

  return (
    <button className={styles.CommandsItemsButton} onClick={props.click}>
      <img src={soundimg} width='35px' alt='Sound Mute'></img>
    </button>
  )
}

export default Mute
